export default {
  STUDENTS: (param) => `/admin/students?page=${param}`,
  ACTIVATION: `/admin/students`,
  SEARCH: `/admin/students/search`,
  STUDENT: (param) => `admin/students/${param}`,
  DELETE_STUDENT: (param) => `admin/students/${param}`,
  /** admin applications */
  APPLICATIONS: `admin/students/applications/approved`,
  APPLICATIONS_SYNCALL: `admin/students/applications/syncAll`,
  APPLICATIONS_SYNC: `admin/students/applications/sync`,
  /** notifications */
  USER_NOTIFICATIONS: `notify`,
  ADMIN_SETTINGS: "admin/students/settings",
  UPDATE_SETTINGS: "admin/students/settings/updateSettings",
};
